import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { shouldHideSortOrder } from '../utils/utils';

import {
  getBrCategoryOptions,
  getBrTypeOptions
} from '../../../../../../../../queries';
import {
  ControlledCheckbox,
  ControlledSelect
} from '../../../../../../../shared';
import ColorPickerPopover from '../../../../../../../shared/ColorPickerPopover';
import { HexColor } from '../../../../../../../shared/ColorPickerPopover/ColorPickerPopover';
import { Option } from '../../../../../../../shared/ControlledFields/ControlledSelect';
import TextField from '../../../../../../../shared/ControlledFields/ControlledTextField';

export const TypeField: React.FC = () => {
  const { data: brTypeOptions } = getBrTypeOptions();
  const { t } = useTranslation('common');
  const { control } = useFormContext();

  return (
    <ControlledSelect
      control={control}
      variant="outlined"
      label={t('costCenters.grid.type')}
      name="type"
      options={brTypeOptions as Option[]}
    />
  );
};

export const CategoryField: React.FC = () => {
  const { data: brCategoryOptions } = getBrCategoryOptions();
  const { t } = useTranslation('common');
  const { control } = useFormContext();

  return (
    <ControlledSelect
      control={control}
      variant="outlined"
      label={t('costCenters.grid.category')}
      name="category"
      options={brCategoryOptions as Option[]}
    />
  );
};

export const SortOrderField: React.FC = () => {
  const { t } = useTranslation('common');
  const { getValues } = useFormContext();
  const { control } = useFormContext();

  if (shouldHideSortOrder(getValues('type'))) {
    return <></>;
  }

  return (
    <TextField
      control={control}
      variant="outlined"
      name="sortOrderAgency"
      label={t('costCenters.grid.sortOrderAgency')}
    />
  );
};

export const RequestExcludeField: React.FC<{ disabled?: boolean }> = (
  props
) => {
  const { t } = useTranslation('common');
  const { control } = useFormContext();

  return (
    <ControlledCheckbox
      {...props}
      control={control}
      name={`REQUEST_EXCLUDE`}
      label={t('costCenters.grid.flags.REQUEST_EXCLUDE')}
    />
  );
};

export const ColorField: React.FC = () => {
  const { t } = useTranslation('common');
  const { setValue } = useFormContext();
  const { control } = useFormContext();
  const onColorSelect = (color: HexColor) => {
    setValue('colorCode', color, { shouldDirty: true });
  };

  return (
    <Controller
      name="colorCode"
      control={control}
      render={({ field }) => (
        <ColorPickerPopover
          color={field.value}
          onColorSelected={onColorSelect}
          hasEditFeature={true}
          label={t('color')}
        />
      )}
    />
  );
};

export const PrivilegedEmailField: React.FC = () => {
  const { t } = useTranslation('common');
  const { control } = useFormContext();

  return (
    <TextField
      control={control}
      variant="outlined"
      name="privilegedEmailAddress"
      label={t('costCenters.grid.privilegedEmailAddress')}
    />
  );
};
